// Bound both the script download and fingerprint calculation. Callers decide whether
// an unavailable fingerprint can be skipped or must block the journey for Retry.
export function loadLandingPageFingerprint(timeoutMs = 3000): Promise<string> {
  return new Promise(resolve => {
    let settled = false;
    const existing = document.getElementById('buzzwave-thumbmark') as HTMLScriptElement | null;
    const script = existing ?? document.createElement('script');
    const finish = (value = '') => {
      if (settled) return;
      settled = true;
      clearTimeout(timer);
      script.removeEventListener('load', onLoad);
      script.removeEventListener('error', onError);
      if (!value && !existing) script.remove();
      resolve(value);
    };
    const onError = () => finish();
    const onLoad = () => {
      void Promise.resolve().then(() => window.ThumbmarkJS.getFingerprint())
        .then(value => finish(typeof value === 'string' ? value : ''), () => finish());
    };
    const timer = setTimeout(() => finish(), timeoutMs);
    script.addEventListener('load', onLoad);
    script.addEventListener('error', onError);
    if (window.ThumbmarkJS) {
      onLoad();
    } else if (!existing) {
      script.id = 'buzzwave-thumbmark';
      script.src = 'https://d2yorki1zywvr7.cloudfront.net/thumbmark.umd.js';
      document.head.appendChild(script);
    }
  });
}
